export const API_ROOT = window.__env.API_ROOT
export const SOCKET_SERVER = window.__env.SOCKET_SERVER
export const NICK_API_ROOT = window.__env.NICK_API_ROOT
export const BASE_URL = window.__env.BASE_URL
